let mixin = {
    // data() {
    //     return {}
    // },
    methods: {
        parseImportData(data) {
            let result = _.every(data, x => {
                try {
                    // The SheetJS has trim the data already
                    // // Trim all data
                    // Object.keys(x).map(k => {
                    //     if (typeof x[k] === 'string')
                    //         x[k] = x[k].trim();
                    // });

                    x.areaCode = '+' + x.areaCode.toString().replace(/[^\d]/g, '');
                    x.phone = x.phone.toString().replace(/[^\d]/g, '');
                    //formatter.parsePhone(x);
                    return true;
                } catch (e) {
                    getApp.snackbar = {
                        show: true,
                        color: 'red',
                        text: e,
                        timeout: 3000
                    };
                    return false;
                }
            });
            console.log('parsed', data);
            return result;
        }
    }
};

export default mixin;